export const STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_VISIBLE = 'taxfixAnnouncementModalVisible'
export const STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_SEEN = 'taxfixAnnouncementModalSeen'
